import { createFileRoute } from '@tanstack/react-router';
import { Unauthenticated } from 'convex/react';
import { lazy } from 'react';
import { LazyComponent as LazyWrapper } from '@/components/ui';

// Fallback to SignInPage for factor-two flow until a dedicated page exists
const SignInPage = lazy(() => import('../template/pages/SignInPage'));

const AuthFactorTwoRoute = () => {
  return (
    <Unauthenticated>
      <LazyWrapper>
        <SignInPage />
      </LazyWrapper>
    </Unauthenticated>
  );
};

export const Route = createFileRoute('/auth/factor-two')({
  component: AuthFactorTwoRoute,
});
